module.exports = __webpack_public_path__ + "img/code5.afc1fe4d.png";